import { showElement, hideElement, queryAll, setExpanded, setAriaLabel, getScreenOverlay } from "./dom.js";

export function initSiteHeader() {
    initNav();
    initSearch();
}

function initNav() {
    const nav = document.getElementById("site-nav");
    if (!nav) return;

    const openTriggers = queryAll('[data-action="nav-open"]');
    const closeTriggers = queryAll('[data-action="nav-close"]');

    openTriggers.forEach(trigger => trigger.addEventListener("click", handleNavOpen));
    closeTriggers.forEach(trigger => trigger.addEventListener("click", handleNavClose));

    function handleNavOpen() {
        showElement(nav);
        openTriggers.forEach(t => {
            setExpanded(t, true);
            setAriaLabel(t, "Close navigation menu");
        });
    }

    function handleNavClose() {
        hideElement(nav);
        openTriggers.forEach(t => {
            setExpanded(t, false);
            setAriaLabel(t, "Open navigation menu");
        });
    }
}

function initSearch() {
    const searchBar = document.querySelector(".site-header__search");
    const header = document.querySelector(".site-header");
    if (!searchBar) return;

    const input = searchBar.querySelector("#header-search");
    const overlay = getScreenOverlay();
    const openTriggers = queryAll('[data-action="header-search-open"]');
    const closeTriggers = queryAll('[data-action="header-search-close"]');

    openTriggers.forEach(trigger => trigger.addEventListener("click", handleSearchOpen));
    closeTriggers.forEach(trigger => trigger.addEventListener("click", handleSearchClose));

    // Clicking the dimmed page closes search
    overlay.addEventListener("click", () => {
        if (header?.classList.contains("site-header--searching")) handleSearchClose();
    });

    function handleSearchOpen() {
        if (header) header.classList.add("site-header--searching");
        showElement(searchBar);
        showElement(overlay);
        openTriggers.forEach(t => {
            setExpanded(t, true);
            setAriaLabel(t, "Close search");
        });
        if (input) input.focus();
    }

    function handleSearchClose() {
        if (header) header.classList.remove("site-header--searching");
        hideElement(searchBar);
        hideElement(overlay);
        openTriggers.forEach(t => {
            setExpanded(t, false);
            setAriaLabel(t, "Open search");
        });
    }
}
